export default "__VITE_ASSET__DqLs41K6__"